export const BONUS_WEEKDAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']

export const BONUS_FROM = {
  DASHBOARD: 'dashboard',
  DEPOSIT: 'deposit',
  BONUS_DETAIL: 'bonus-detail'
}
